import { render, staticRenderFns } from "./reviewMe.vue?vue&type=template&id=18202ce4&scoped=true&"
import script from "./reviewMe.vue?vue&type=script&lang=js&"
export * from "./reviewMe.vue?vue&type=script&lang=js&"
import style0 from "./reviewMe.vue?vue&type=style&index=0&id=18202ce4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18202ce4",
  null
  
)

export default component.exports